export interface INakladyParams {
    od: number
    do: number
    int: number
    list: number[]
    selected: number;
}

export class NakladyParams implements INakladyParams{
    od: number=0;
    do: number=0;
    int: number=0
    list: number[]=[1];
    selected: number=1;
}